module.exports = __webpack_public_path__ + "img/cross-circle.0d161881.svg";